import { Component, ReactNode } from "react";

import WebDesigner from "./WebDesigner";
import HierarchyBrowser from "./HierarchyBrowser";
import React from "react";
import GetAttributeDefinition, {
  AttributeTargetType,
  GetWBComponentByTypename,
} from "./Data/WBData";
import DeleteIcon from "./Icons/DeleteIcon";
import { GetScreensizeIcon } from "./Icons/ScreenSizeIcons";
import RenderModularInput from "./StyleInputs/RenderModularInput";
import LayoutNode, {
  setNodeComponentAttributeValue,
  setNodeStyleAttributeValue,
  AttributeCollection,
  getNodeStyleAttributeValue,
} from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import ButtonsSettingsMenu from "./Menus/ButtonSettingsMenu";
import PageSpacingMenu from "./Menus/PageSpacingMenu";
import HeightAndWidthField from "./StyleInputs/HeightAndWidthField";
import RenderAttributeInput from "./StyleInputs/RenderAttributeInput";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import {

  ResizeableType,

} from "./WBComponents/WBComponent";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import { SiteData } from "./Data/SiteData";
import { DuplicateIcon } from "./Icons/DuplicateIcon";
import FontPairsMenu from "./Menus/FontPairsMenu";
import SiteStyleCollectionMenu from "./Menus/SiteStyleCollectionMenu";
import { CSSClassNames } from "./CSSClassNameConstants";
import ColorPaletteMenu from "./Menus/ColorPalleteMenu";
import HoverToolTip from "./HoverToolTip";
import ImageMappingMenu from "./Menus/ImageMappingMenu";
import AnnouncementBarMenu from "./Menus/AnnouncementBarMenu";
import { LinkToEditInVagaroFromLink } from "./StyleInputs/LinkToEditInVagaro";
import CookieBannerMenu from "./Menus/CookieBannerMenu";
import PopupMenu from "./Menus/PopupMenu";
import { IsNodeInGrid } from "./Utilities/GridUtils";
import GridAreaField from "./StyleInputs/GridAreaField";
import FontScalingMenu from "./Menus/FontScalingMenu";


export function CalculateColumnWidths(screenSize:ScreenSize,section:LayoutNode){

  let total = 0;
  let growList:any[]  = [];
  for(let i = 0;i<section.children.length;i++){
      const child = section.children[i];
      const grow = getNodeStyleAttributeValue(child,screenSize,"flexGrow","1");
      let num = parseFloat(grow);
      total += num;
      growList.push({node:child,grow:num});
  }

  if(total>0)
  for(let i = 0;i<growList.length;i++){

      let percent = growList[i].grow/total*100;
      setNodeStyleAttributeValue(growList[i].node,screenSize,"minWidth",percent+"%");
      setNodeStyleAttributeValue(growList[i].node,screenSize,"maxWidth",percent+"%");

      growList[i].node.forceUpdate&&growList[i].node.forceUpdate();
  }


}



export enum StyleBuilderState {
  SelectedComponent,
  Fonts,
  Colors,
  Headings,
  Paragraphs,
  Buttons,
  Links,
  PageSpacing,
  ImageMapping,
  AnnouncementBar,
  CookieBanner,
  Popup,
  FontScaling

}

type StyleBuilderProps = {
  components: { dom: HTMLElement; layout: LayoutNode }[];
  manager: WebDesigner;
  screenSize: ScreenSize;
  styleEditState: StyleBuilderState;
  siteData: SiteData;

};



function RightCaret(props: any) {
  return (
    <div style={{ width: "5px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
        fill="currentColor"
      >
        <path d="M273 239c9.4 9.4 9.4 24.6 0 33.9L113 433c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l143-143L79 113c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L273 239z" />
      </svg>
    </div>
  );
}

function MoveUp() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#333"
      height="16"
      viewBox="0 0 384 512"
    >
      <path d="M32 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l96 0c53 0 96-43 96-96l0-306.7 73.4 73.4c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 109.3 160 416c0 17.7-14.3 32-32 32l-96 0z" />
    </svg>
  );
}

function MoveDown() {
  // return <svg xmlns="http://www.w3.org/2000/svg"  fill="#333"height="16" viewBox="0 0 384 512"><path d="M24 464c-13.3 0-24 10.7-24 24s10.7 24 24 24l104 0c48.6 0 88-39.4 88-88l0-342.1 87 87c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L209 7c-9.4-9.4-24.6-9.4-33.9 0L47 135c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l87-87L168 424c0 22.1-17.9 40-40 40L24 464z"/></svg>
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="#333"
      height="16"
      viewBox="0 0 384 512"
    >
      <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z" />
    </svg>
  );
}

export type UpdateStyleFunction = (
  attribute: string,
  value: string,
  targetType: AttributeTargetType
) => void;

function RenderParentList({
  current,
  manager,
}: {
  current: LayoutNode;
  manager: WebDesigner;
}) {
  let list: LayoutNode[] = [];
  while (
    current.parent != null &&
    current.typename != wBComponentTypeNames.pageRoot
  ) {
    list.push(current);
    current = current.parent;
  }

  if (list.length <= 1) return null;

  list.reverse();

  return (
    <div className="parent-list">
      {list.map((obj, index) => {
        let name = GetWBComponentByTypename(obj.typename).displayName;
        return (
          <React.Fragment key={index}>
            {index != 0 && <RightCaret key={index + "parent"} />}
            <div
              onMouseOver={() => manager.hoverById(obj.id)}
              className={"parent-list-item "+CSSClassNames.overrideHover}
              key={index}
              onClick={() => manager.selectElementByLayoutObj(obj)}
              onMouseEnter={() => manager.hoverById(obj.id)}
            >
              {name}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default class StyleBuilder extends Component<StyleBuilderProps, {}> {
  constructor(props: StyleBuilderProps) {
    super(props);



    this.updateAttributeByKeyAndValueByCurrentScreensize =
      this.updateAttributeByKeyAndValueByCurrentScreensize.bind(this);
    this.saveAttributeUpdates = this.saveAttributeUpdates.bind(this);
  }

  updateAttributeByKeyAndValueByCurrentScreensize(
    attribute: string,
    value: string,
    targetType = AttributeTargetType.Style,
    checkForSepcial = true
  ) {
    const screenSize = this.props.screenSize;


  this.props.manager.flagDirtySave();
    //a few special cases where we need to update multiple attributes due to behavior of css
    if (checkForSepcial) {
      switch (attribute) {
        case "alignContent":
          this.updateAttributeByKeyAndValueByCurrentScreensize(
            "alignItems",
            value,
            targetType,
            false
          );
          break;
        case "alignItems":
          this.updateAttributeByKeyAndValueByCurrentScreensize(
            "alignContent",
            value,
            targetType,
            false
          );
          break;
        case "opacity":
          if(value=="1")
            value = "";
          break;

        case "position": // bring absolute positioned elements to front to allow selecting from getElementAtPoint since they are rendered that way anyway
            if(value=="absolute"){
              this.updateAttributeByKeyAndValueByCurrentScreensize(
                "zIndex",
                "1",
                targetType,
                false
              );
            }
            else{
              this.updateAttributeByKeyAndValueByCurrentScreensize(
                "zIndex",
                "",
                targetType,
                false
              );
            }
            break;
        default:
          break;
      }
    }

    this.props.manager.componentDirty = true;

    for (let i = 0; i < this.props.components.length; i++) {
      let target = this.props.components[i].layout;
      let comp = GetWBComponentByTypename(target.typename);


      if (!comp.editList.includes(attribute)) continue;
      if (targetType == AttributeTargetType.Component) {
        setNodeComponentAttributeValue(target, attribute, value);
        //this.props.manager.updateMasterLayout();
        if(target?.forceUpdate){
        target?.forceUpdate();
        }
        else{
          this.props.manager.updateMasterLayout();
        }
      } else {
        setNodeStyleAttributeValue(target, screenSize, attribute, value);

       if(target?.forceUpdate)
        target?.forceUpdate();

        else{
          this.props.manager.updateMasterLayout();
        }

      }

      comp.OnApplyAttribute(target, attribute, value, this.props.manager);
    }
  }

  saveAttributeUpdates() {

    this.props.manager.saveUndoState();
    this.props.manager.updateMasterLayout();
    this.props.siteData.isStyleSaveDirty = true;
  }

  componentDidMount(): void {
    this.props.manager.styleBuilder = this;
  }

  render() {
    const tryComponent = this.props.manager.latestSelection();


    if (
      this.props.styleEditState == StyleBuilderState.SelectedComponent &&
      (!tryComponent||!tryComponent.layout)
    ) {
      return (
        <div className={"wb-panel right-panel nice-scroll"}>
          <div>
            {/* <br></br>
            <h6 className="panel-heading center-all no-select" style={{ opacity: ".5" }}>
              No Component Selected
            </h6> */}
          </div>
          <HierarchyBrowser rootNode={this.props.manager.state.layout} designer={ this.props.manager} />


        </div>
      );
    }

    const targetLayout = tryComponent?.layout;

    const componentDef = GetWBComponentByTypename(targetLayout?.typename ?? "");

    const inGrid = targetLayout?IsNodeInGrid(targetLayout):false;

    // if(targetLayout?.typename == wBComponentTypeNames.column||targetLayout?.typename == wBComponentTypeNames.row){
    //   tooltip = "To resize Columns or Rows relative to eachother use the [Flex Grow] option"
    // }

    return (
      <div className={"wb-panel right-panel nice-scroll"}

        onContextMenu={(e) => {

          if(e.target){

            let target = e.target as HTMLElement;
            if(target.tagName=="INPUT"||target.tagName=="TEXTAREA"){
              return;
            }
          }

          if(targetLayout){
          this.props.manager.openContextMenu(e.clientX, e.clientY, targetLayout);
            e.preventDefault();
            e.stopPropagation();
          }
        }}
      >
        {/*
        {render selected component options} */}
        {this.props.styleEditState == StyleBuilderState.SelectedComponent &&
          targetLayout && (
            <>
              <div
              id='sticky-comp-heading'
              className="flex-column "
                style={{

                  margin:"0 -10px -8px -10px",
                  padding:"0 10px 8px 8px",
                  position:"sticky",
                  top:0,
                  background:"#f8f8f8",
                  zIndex:16,

                }}
              >
                <div className="flex-row align-center w-full justify-between">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <h2 className="panel-heading">{componentDef.displayName}</h2>
                </div>
                {/* DUPLICATE AND DELETE BUTTONS*/}

                {!componentDef.isStatic && (
                  <div className="component-action-buttons">
                   {!inGrid? <>
                    {this.props.manager.objectCanMoveInDirection(
                      targetLayout,
                      1
                    ) ? (
                      <button
                        className="invisible-button has-tip"
                        onClick={() => {
                          this.props.manager.moveComponentAdjacent(
                            targetLayout,
                            1
                          );
                        }}
                      >
                        <MoveDown />
                        <HoverToolTip text="Move Forward"/>
                      </button>
                    ) : (
                      <button
                        className="invisible-button has-tip"
                        style={{ opacity: ".4", cursor: "default" }}
                      >
                        <MoveDown />
                        <HoverToolTip text="Move Forward"/>
                      </button>
                    )}

                    {this.props.manager.objectCanMoveInDirection(
                      targetLayout,
                      -1
                    ) ? (
                      <button
                        className="invisible-button"
                        onClick={() => {
                          this.props.manager.moveComponentAdjacent(
                            targetLayout,
                            -1
                          );
                        }}
                      >
                        <MoveUp />
                        <HoverToolTip text="Move Backward"/>
                      </button>
                    ) : (
                      <button
                        className="invisible-button"
                        style={{ opacity: ".4", cursor: "default" }}
                      >
                        <MoveUp />
                        <HoverToolTip text="Move Backward"/>
                      </button>
                    )}
              </>:<GridMovementDropdown layoutNode={targetLayout} designer={this.props.manager} />}
                    <button
                      className="invisible-button"
                      onClick={() => {
                        this.props.manager.duplicateOjbectInPlace(targetLayout);
                      }}
                    >
                      <DuplicateIcon />
                      <HoverToolTip text="Duplicate"/>
                    </button>
                    <button
                      className="invisible-button "
                      onClick={() => {
                        this.props.manager.deleteSelectedDoms();
                      }}
                    >
                      <DeleteIcon />
                      <HoverToolTip text="Delete"/>
                    </button>
                  </div>
                )}
</div>
{
                <RenderParentList
                  current={targetLayout}
                  manager={this.props.manager}
                />
              }
              </div>

              {componentDef.description.length>0&&
              <div style={{fontSize:"12px",lineHeight:"16px",color:"#777",marginTop:"8px"}} >{componentDef.description}</div>

              }


              {!inGrid&& componentDef.resizeType != ResizeableType.None && componentDef.resizeType != ResizeableType.flexGrow && componentDef.resizeVisibilty[this.props.screenSize] &&
              (
                <>
                  <div className="wb-input-group">
                    <label >

                      <span className="icon-label">
                        <GetScreensizeIcon screenSize={this.props.screenSize} /> Size
                      </span>

                    </label>
                    <HeightAndWidthField
                      label=""
                      screenSize={this.props.screenSize}
                      component={componentDef}
                      domObject={this.props.components[0].dom}
                      key={targetLayout.id + "sizing"}
                      layoutObject={targetLayout}
                      updateFunc={
                        this.updateAttributeByKeyAndValueByCurrentScreensize
                      }
                      widthAtt="width"
                      heightAtt="height"
                      xLabel="width:"
                      yLabel="height:"
                    />
                  </div>
                </>
              )}
              {inGrid&&
              <GridAreaField layoutObject={targetLayout} updateFunc={this.updateAttributeByKeyAndValueByCurrentScreensize} screenSize={this.props.screenSize} saveFunc={this.saveAttributeUpdates}  />

              }
              {
                componentDef.vagaroLink&&<LinkToEditInVagaroFromLink link={componentDef.vagaroLink} />
              }

              <componentDef.RenderMenu
                primaryList={componentDef.primaryEditAttributes}
                editList={componentDef.editList}
                layoutNode={targetLayout}
                screenSize={this.props.screenSize}
                updateFunc={
                  this.updateAttributeByKeyAndValueByCurrentScreensize
                }
                saveFunc={this.saveAttributeUpdates}
                siteData={this.props.siteData}

              />

            </>
          )}

        {this.props.styleEditState == StyleBuilderState.PageSpacing && (
          <>
            <PageSpacingMenu
              saveFunc={this.saveAttributeUpdates}
              siteData={this.props.siteData}
            />
          </>
        )}
        {this.props.styleEditState == StyleBuilderState.Buttons && (
          <ButtonsSettingsMenu
            saveFunc={this.saveAttributeUpdates}
            siteData={this.props.siteData}
          />
        )}
        {this.props.styleEditState == StyleBuilderState.Fonts && (
          <>
            <FontPairsMenu  siteData={this.props.siteData} />
          </>
        )}
        {this.props.styleEditState == StyleBuilderState.FontScaling && (
          <>
            <FontScalingMenu  siteData={this.props.siteData} />
          </>
        )}
        {this.props.styleEditState == StyleBuilderState.ImageMapping &&
          <ImageMappingMenu siteData={this.props.siteData} saveFunc={this.saveAttributeUpdates} />
        }

    {this.props.styleEditState == StyleBuilderState.AnnouncementBar &&
      <AnnouncementBarMenu siteData={this.props.siteData} saveFunc={this.saveAttributeUpdates} />
    }
    {this.props.styleEditState == StyleBuilderState.CookieBanner &&
    <>
            <CookieBannerMenu siteData={this.props.siteData} saveFunc={this.saveAttributeUpdates} />

    </>
    }

{this.props.styleEditState == StyleBuilderState.Popup &&
    <>
   <PopupMenu siteData={this.props.siteData} saveFunc={this.saveAttributeUpdates} />

        </>
        }



{this.props.styleEditState == StyleBuilderState.Colors && (
        <ColorPaletteMenu siteData = {this.props.siteData} saveFunc={this.saveAttributeUpdates} />
        )}

        {this.props.styleEditState == StyleBuilderState.Headings && (
          <SiteStyleCollectionMenu
            title="Headings"
            saveFunc={this.saveAttributeUpdates}
            siteData={this.props.siteData}
            collectionList={[
              this.props.siteData.siteStyling.heading1,
              this.props.siteData.siteStyling.heading2,
              this.props.siteData.siteStyling.heading3,
              this.props.siteData.siteStyling.heading4,
            ]}
            labelList={["H1", "H2", "H3", "H4"]}
            componentType={wBComponentTypeNames.heading}
          />
        )}

{this.props.styleEditState == StyleBuilderState.Paragraphs && (
          <SiteStyleCollectionMenu
            title="Paragraphs"
            saveFunc={this.saveAttributeUpdates}
            siteData={this.props.siteData}
            collectionList={[
              this.props.siteData.siteStyling.paragraph1,
              this.props.siteData.siteStyling.paragraph2,
              this.props.siteData.siteStyling.paragraph3,
            ]}
            labelList={["P1", "P2", "P3"]}
            componentType={wBComponentTypeNames.text}
          />
        )}

{this.props.styleEditState == StyleBuilderState.Links && (
          <SiteStyleCollectionMenu
            title="Links"
            saveFunc={this.saveAttributeUpdates}
            siteData={this.props.siteData}
            collectionList={[
              this.props.siteData.siteStyling.link,
            ]}
            labelList={["Link"]}
            componentType={wBComponentTypeNames.text}
          />
        )}


      </div>
    );
  }





  //sepecifc function for buttons to inlcude the tabs + button settings per button selected
}

function GridMovementDropdown({layoutNode,designer}:{layoutNode:LayoutNode,designer:WebDesigner}){

  const [showMenu,setShowMenu] = React.useState(false);

  const domRef = React.useRef<HTMLDivElement>(null);
  const handleClickOutside = (e:MouseEvent)=>{
    if(domRef.current&&showMenu){
      if(!domRef.current.contains(e.target as Node)){
        setShowMenu(false);
      }
    }
  }

  React.useEffect(() => {
    if(showMenu)
      document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  return<div className="relative" ref={domRef} style={{width:"28px"}} > <button
  onClick={()=>{setShowMenu(!showMenu)}}
  className="invisible-button has-tip relative"><SendToBackIcon/>
   <HoverToolTip text="Move"/>
  </button>
  { showMenu&&<div className="select-dropdown-options context-menu" style={{position:"absolute",top:"16px",right:"-32px"}}>
    <button disabled={!designer.objectCanMoveInDirection(layoutNode,1)}  onClick={()=>{setShowMenu(false); designer.moveComponentAdjacent(layoutNode,1)}}           className="invisible-button flex-row align-center gap-med"><MoveForwardIcon/>Move Forward</button>
    <button disabled={!designer.objectCanMoveInDirection(layoutNode,-1)} onClick={()=>{setShowMenu(false); designer.moveComponentAdjacent(layoutNode,-1)}}          className="invisible-button flex-row align-center gap-med"><MoveBackwardIcon/>Move Back</button>
    <button disabled={!designer.objectCanMoveInDirection(layoutNode,1)}  onClick={()=>{setShowMenu(false); designer.moveComponentToStartOrBack(layoutNode,true)}}   className="invisible-button flex-row align-center gap-med"><BringToFrontIcon/>Bring to Front</button>
    <button disabled={!designer.objectCanMoveInDirection(layoutNode,-1)} onClick={()=>{setShowMenu(false); designer.moveComponentToStartOrBack(layoutNode,false)}}  className="invisible-button flex-row align-center gap-med"><SendToBackIcon/>Send to Back</button>
  </div>


  }

  </div>


}

export function SendToBackIcon(){
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 640 512"><path d="M256 208V48a48 48 0 0 0 -48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48zM48 48h160v160H48zm384 176h48v-80a48 48 0 0 0 -48-48H288v48h144zM96 160h64V96H96zm496 96H432a48 48 0 0 0 -48 48v160a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0 -48-48zm0 208H432V304h160zM208 288h-48v80a48 48 0 0 0 48 48h144v-48H208zm336 64h-64v64h64z"/></svg>
}

export function BringToFrontIcon(){
  return <svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" height={"1em"} viewBox="0 0 640 512"><path d="M480 368V144a48 48 0 0 0 -48-48H208a48 48 0 0 0 -48 48v224a48 48 0 0 0 48 48h224a48 48 0 0 0 48-48zM208 144h224v224H208zM48 48h160v16h48V48a48 48 0 0 0 -48-48H48A48 48 0 0 0 0 48v160a48 48 0 0 0 48 48h80v-48H48zm544 208h-80v48h80v160H432v-16h-48v16a48 48 0 0 0 48 48h160a48 48 0 0 0 48-48V304a48 48 0 0 0 -48-48zM96 160h32v-16a79.2 79.2 0 0 1 16.4-48H96zm448 192h-32v16a79.2 79.2 0 0 1 -16.4 48H544z"/></svg>
}

export function MoveForwardIcon(){

  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 512 512"><path d="M352 304V48a48 48 0 0 0 -48-48H48A48 48 0 0 0 0 48v256a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48zM48 48h256v256H48zm416 112h-80v48h80v256H208v-80h-48v80a48 48 0 0 0 48 48h256a48 48 0 0 0 48-48V208a48 48 0 0 0 -48-48zM240 416a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16V256a16 16 0 0 0 -16-16h-32v144H240z"/></svg>
}

export function MoveBackwardIcon(){
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 512 512"><path d="M48 48H304v80h48V48A48 48 0 0 0 304 0H48A48 48 0 0 0 0 48V304a48 48 0 0 0 48 48h80V304H48zM256 432H416a16 16 0 0 0 16-16V256a16 16 0 0 0 -16-16H256a16 16 0 0 0 -16 16V416A16 16 0 0 0 256 432zm32-144h96v96H288zM464 160H208a48 48 0 0 0 -48 48V464a48 48 0 0 0 48 48H464a48 48 0 0 0 48-48V208A48 48 0 0 0 464 160zm0 304H208V208H464z"/></svg>
}


export function MapInputsFromEditList({
  editList,
  layoutNode,
  screenSize,
  modular,
  updateFunc,
  saveFunc,
  showScreenSize = true,
  siteData,
  sort,
  onDeleteModular = () => {},

}: {
  updateFunc: UpdateStyleFunction;
  onDeleteModular?: Function;
  saveFunc: Function;
  modular?: boolean;
  editList: string[];
  layoutNode: AttributeCollection | null;
  screenSize: ScreenSize;
  showScreenSize?: boolean;
  sort?: boolean;
  siteData: SiteData;

}) {
  if (!layoutNode) return <></>;


  if(sort)
    editList.sort();



  return (
    <>
      {editList.map((att, index) => {
        let def = GetAttributeDefinition(att);
        // let label = componentDef.getAttributeLabel(att, def.label, targetLayout);

        let labelNode =
          def.targetType == AttributeTargetType.Style && showScreenSize ? (
            <span className="icon-label">
         <GetScreensizeIcon screenSize={screenSize} />
              {def.label}
            </span>
          ) : (
            <>{def.label}</>
          );


        const wrappedLable = (def.description.length>0)?<span>{labelNode}<HoverToolTip text={def.description} checkScroll={true}/></span>:labelNode;



        const newProps = {
          screenSize:screenSize,
          label:wrappedLable,
          key:layoutNode.id + att + index + screenSize,
          definition:def,
          layoutObject:layoutNode,
          updateFunc:updateFunc,
          saveFunc:saveFunc,
          siteData:siteData
        }

        if(modular){
          let newDef = {...def};

          newDef.options = [...def.options]


          if(newDef.options.length>0&&newDef.options[0].value===""){
            newDef.options.splice(0,1);
          }

          newProps.definition = newDef;

        }

        return  modular? <RenderModularInput {...newProps} onDelete={onDeleteModular}/>: <RenderAttributeInput {...newProps} />;

      })}
    </>
  );
}

export function RenderScreensizeLabel({
  screenSize,
  label,
  children
}: {
  screenSize: ScreenSize;
  label: ReactNode;
  children?: ReactNode;
}) {
  return (
    <span className="icon-label">
       <GetScreensizeIcon screenSize={screenSize} />
      {label}
      {children}
    </span>
  );
}
